namespace Solovis.UI.InputControls {

    export interface ValidationStateData {
        success?: {
            message?: string;
            html?: string | JQuery;
        };

        error?: {
            message?: string;
            serverError?: boolean;
        };
    }

    /**
     * ValidationModel is the standard representation of error state for FormBuilder and FormEntry.
     */
    export class ValidationModel {

        public _state: ValidationStateData = null;

        constructor() {
        }

        public clearState() {
            this.state(null);
        }

        public setErrorMessage(message: string) {
            var newState = {
                error: {
                    message: message
                }
            };

            this.state(newState);
        }

        public setSuccessMessage(message: string) {
            var newState = {
                success: {
                    message: message
                }
            };

            this.state(newState);
        }

        public state(newState?: ValidationStateData): ValidationStateData {            
            if (!arguments.length) {
                // Retrieve current state.
                return this._state;
            }
            else {
                // Modify state.
                this._state = newState;
                $(this).trigger("stateChanged", { validationModel: this, state: newState });

                return this._state;
            }
        }

        public hasError(): boolean {
            if (this._state && this._state.error) {
                return true;
            }
            return false;
        }
    }

}
